<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="4">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form>
                                    <div class="text-center">
                                        <img :src="logo" style="width: 150px;margin: 15px;">
                                    </div>
                                    <h1 class="text-center">Cocoonin</h1>
                                    <p class="text-muted text-center">
                                        Sign In to your account
                                    </p>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-user"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            type="text"
                                            class="form-control"
                                            placeholder="Account"
                                            v-model="model.username"
                                            @keypress.enter="emailPressHandler"
                                        />
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-lock"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            type="password"
                                            class="form-control"
                                            placeholder="Password"
                                            v-model="model.password"
                                            ref="password"
                                            @keypress.enter="clickLoginHandler"
                                        />
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-button
                                                variant="primary"
                                                class="px-4 btn-block"
                                                @click="clickLoginHandler"
                                                >Login</b-button
                                            >
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import moment from "moment";
export default {
    name: "Login",
    data: function () {
        return {
            model: {
                grant_type: "password",
                username: "",
                password: "",
            },
            logo: this.$base() + 'image/logo'
        };
    },
    created: function () {
        localStorage.removeItem("jwt");
        localStorage.removeItem("jwt@exp");
    },
    methods: {
        clickLoginHandler: function () {
            let _this = this;
            let loading = this.$loading.show();
            axios({
                method: "POST",
                url: _this.$base() + "account/login",
                data: qs.stringify(this.model),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .then(function (res) {
                    if (res.status == 200) {
                        if (res.data.access_token != undefined) {
                            let toten = CryptoJS.AES.encrypt(res.data.access_token, "2693ef35-1474-40f9-93ec-2b18c8059014").toString();
                            let expired_time = moment()
                                .utc()
                                .add(res.data.expires_in - 1000, "seconds")
                                .format("YYYYMMDDHHmmss");
                            localStorage.setItem("jwt", toten);
                            localStorage.setItem("jwt@exp", expired_time);
                            _this.initialize();
                        } else {
                            Swal.fire(
                                res.data.error,
                                res.data.error_description,
                                "warning"
                            );
                        }
                    }
                })
                .catch(function (err) {
                    Swal.fire("Message", err.toString(), "warning");
                })
                .finally(function () {
                    loading.hide();
                });
        },
        emailPressHandler: function () {
            this.$refs.password.focus();
        },
        initialize(){
            this.$api().post('initialize').then(res => {
                if (this.$isValid(res)) {
                    const data = res.data.Json;
                    let lang = data.Lang;
                    if(lang == undefined || lang == null || lang == '') lang = 'en';
                    this.$store.state.lang = lang;
                    this.$i18n.locale = lang;
                    this.$store.commit('updateUserGroup', data.UserGroup);
                    this.$store.commit('updateCompany', { ...data.Company, UserLogin: data.UserLogin });
                    this.$router.push("/");
                }
            });        
        }
    },
};
</script>
<style>
.card-group > .card {
    border: none;
    box-shadow: none;
    border-radius: 3px;
}
</style>
